/** The world's list of changes, as the tools read it. */

/** One change as the list shows it. */
export interface EditSummary {
  what: string;
  by: string;
  at: number;
  size: number;
}

/** The list the world sends, read carefully: a bad one is an empty one. */
export function readEdits(text: string | undefined): EditSummary[] {
  if (!text) return [];
  try {
    const held: unknown = JSON.parse(text);
    return Array.isArray(held) ? (held as EditSummary[]) : [];
  } catch {
    return [];
  }
}
